import React from 'react'
import { FormContact as Form, LocationTable, LocationPopup } from '.'
import { Plus } from 'react-feather'
import { useViewport, viewportBreakpoint, MobileViewportProvider } from '../../../utils'
import { Radio } from '../../../components'
import { useHistory } from 'react-router-dom'

const initialForm = {
  visibilityHeadquarter: 'public',
  visibilityCabang: 'public',
}

const VisibilitySwitch = ({form, updateForm, className, ...props}) => {
  return (
    <div className={`flex items-center ${className}`} {...props}>
      <p className="text-sm font-bold mr-4">Visibility:</p>
      <Radio
        name="visibilityCabang"
        id="visibility1"
        label="Public"
        value="public"
        className="mr-4"
        form={form}
        onChange={updateForm}
      />
      <Radio
        name="visibilityCabang"
        id="visibility2"
        label="Only me"
        value="onlyme"
        form={form}
        onChange={updateForm}
      />
    </div>
  )
}

const ContentOfficialContact = () => {
  const history = useHistory()
  const [popedUp, setPopedUp] = React.useState(false)
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet
  const [form, setForm] = React.useState(initialForm)

  const updateForm = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  return (
    <div>
      <div className="xl:w-2/3">
        <Form form={form} updateForm={updateForm}/>
      </div>
      <hr className="my-8 lg:my-10"/>
      <div className="flex justify-between items-center mb-3 lg:mb-8">
        <div className="flex items-center">
          <p className="text-lg font-bold">Cabang</p>
          <div className="hidden lg:block mx-5">|</div>
          <div className="hidden lg:block">
            <VisibilitySwitch form={form} updateForm={updateForm}/>
          </div>
        </div>
        <div
          className="text-sm text-primary flex items-center cursor-pointer"
          // onClick={() => setPopedUp(true)}
          onClick={() => history.push('/dashboard/profile/location/edit')}
        >
          <Plus className="lg:mr-1" style={{width: isMobile ? '18px' : '14px'}}/>
          <p className="">Add <span className="hidden lg:inline">New Location</span></p>
        </div>
      </div>
      <MobileViewportProvider>
        <VisibilitySwitch form={form} updateForm={updateForm} className="mb-5"/>
      </MobileViewportProvider>
      <div className="mobile-fullwidth">
        <LocationTable
          // onEdit={() => setPopedUp(true)}
          onEdit={() => history.push('/dashboard/profile/location/edit')}
        />
      </div>
      {
        popedUp &&
        <LocationPopup onClose={setPopedUp}/>
      }
    </div>
  )
}

export { ContentOfficialContact }
